const SafetyIconPetrolRestriction = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="36"
      height="36"
      rx="18"
      fill="#DC2626"
    />
    <path
      d="M26.9475 16.4716V21.5269C26.9475 24.1073 26.9475 25.3975 26.161 26.1983C25.3754 27 24.1094 27 21.579 27H14.4212C11.8908 27 10.6248 27 9.83921 26.1983C9.05273 25.3984 9.05273 24.1073 9.05273 21.5278V19.0252C9.05273 17.1498 9.05273 16.2113 9.54752 15.4999C10.0432 14.7886 10.9111 14.4799 12.6478 13.8599L19.8057 11.3054C23.0589 10.1449 24.6856 9.56426 25.8165 10.3829C26.4321 10.8276 26.7122 11.5506 26.8401 12.6842"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.7363 13.6324C11.7363 12.4648 11.7363 11.8814 12.0387 11.4788C12.1175 11.3744 12.2076 11.2825 12.309 11.2032C12.7026 10.8945 13.2753 10.8945 14.4205 10.8945H15.1524C15.6061 10.8945 15.8333 10.8945 16.0203 10.9455C16.2703 11.0151 16.4975 11.1493 16.6791 11.3347C16.8607 11.52 16.9902 11.75 17.0546 12.0013"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7 7L29 29M29 7L7 29"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default SafetyIconPetrolRestriction
